<template>
  <div v-if="!hasCustomer()">
    <assigned-researchers-list
      :researchers="researchers"
      @add-researcher="showUsersListModal"
      id="assigned-researchers-list"
    ></assigned-researchers-list>

    <users-modal
      ref="users-modal"
      :selected-users="researchers"
      :load-users-function="getResearchers"
      @user-selected="addResearcher"
    ></users-modal>
  </div>
</template>

<script>
import "jquery-validation";
import UsersModal from "../components/users/UsersModal";
import AssignedResearchersList from "../components/users/AssignedResearchersList";
import { mapActions } from "vuex";
import "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Spanish } from "flatpickr/dist/l10n/es";

export default {
  name: "AssignEthicCourse",
  components: {
    UsersModal,
    AssignedResearchersList,
  },
  data() {
    return {
      researchers: [],
    };
  },
  methods: {
    ...mapActions({
      getResearchers: "users/getResearchers",
    }),

    async addResearcher(user, callback) {
      this.researchers.push(user);

      if (callback) {
        callback();
      }
    },

    showUsersListModal() {
      this.$refs["users-modal"].clearSearch();
      this.$refs["users-modal"].load();
    },

    hasCustomer() {
      return $('input[name="id"]').val();
    },
  },
  mounted() {
    const $form = $(".form");
    const component = this;
    const $expiresAt = $('#expires_at')

    $expiresAt.flatpickr({
      disableMobile: false,
      dateFormat: "d/m/Y",
      locale: Spanish,
    });

    this.starDate = $expiresAt.get(0)._flatpickr

    /**
     * Init JQuery validation
     */
    $(() => {
      $form.validate({
        ignore: [],
        highlight: function (element, errorClass, validClass) {
          $(element).addClass("is-invalid");
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
        errorPlacement: function (label, element) {
          label.addClass("invalid-feedback");
          label.insertAfter(element);
        },
        rules: {
          researchers: {
            required: true,
          },
          course_id: {
            required: true,
            maxlength: 255,
          },
          expires_at: {
            required: true,
          },
          voucher: {
            required: true,
          },
        },
        messages: {
          course_id: {
            required: "Este campo es requerido.",
            maxlength: "El texto no debe superar los 255 caracteres.",
          },
          expires_at: {
            required: "Seleccione una fecha",
            date: "Proporcione una fecha de vencimiento.",
          },
          voucher: {
            required: "Seleccione el comprobante",
          },
        },
        submitHandler(form) {
          // Add researchers as hidden inputs.
          $('input[name="researchers[]"]').remove();

          component.researchers.forEach((researcher) => {
            $form.prepend(
              `<input type="hidden" name="researchers[]" value="${researcher.id}" />`
            );
          });

          if (
            component.hasCustomer() ||
            $('input[name="researchers[]"]').length
          ) {
            $("#btn-save, #btn-cancel").prop("disabled", true).addClass('disabled');
            $("#btn-save").find(".spinner-border").removeClass("d-none");

            form.submit();
          } else {
            $("#assigned-researchers-list")
              .css("border", "1px solid #d90000")
              .after(
                '<label class="error invalid-feedback d-block">Seleccione por lo menos un investigador</label>'
              );
          }
        },
      });

      $form.removeClass("invisible");
    });
  },
};
</script>
